import React from 'react'
import { useSelector } from 'react-redux'

const ListofTask = () => {
  const { allTasks } = useSelector(({ property }) => property)

  return (
    <>
      <ol className="common_order_list_div">
        {allTasks?.map((tasks, index) => (
          <li key={index}>{tasks?.task}</li>
        ))}
      </ol>
    </>
  )
}

export default ListofTask
